import omit from 'lodash-es/omit.js';
import { hash } from 'ohash';
import { isEqualArray } from '@salsita-ai/platform-common/utils';
import { AnyDomainEntity, Shorts } from '../__generated/model/index.js';
const excludedFields = [
    {
        types: AnyDomainEntity.types,
        fields: [
            'id'
        ]
    },
    {
        types: Shorts.types,
        fields: [
            'size'
        ]
    }
].reduce((acc, { types, fields })=>{
    types.forEach((type)=>{
        acc[type] = (acc[type] ?? []).concat(fields);
    });
    return acc;
}, {});
export const computeStandardProductHashes = (entities)=>{
    return entities.map((entity)=>{
        return hash(omit(entity, excludedFields[entity.type] ?? []));
    }).sort();
};
export const matchesStandardProductHashes = (entities, standardProductHashes)=>{
    const entityHashes = computeStandardProductHashes(entities);
    return isEqualArray(entityHashes, standardProductHashes);
};

//# sourceMappingURL=standard-product-hash.js.map